import Style from "./style"

import PageTitle from "widget/PageTitle"
import Pagenation from "widget/Pagenation"

import useGetYoutubeList from "entity/column/useGetYoutubeList"

import timestampCalculator from "shared/lib/timestampCalculator"

const YoutubeList = () => {

    const [youtubeList] = useGetYoutubeList()

    return (
        <Style.Wrapper>
            <PageTitle>유튜브</PageTitle>

            <Style.List>
                {youtubeList?.data?.youtube_list?.map(elem =>
                    <Style.Element onClick={() => window.location.href = elem?.url}>
                        <img src={elem?.img} />
                        <div>
                            <h2>{elem?.title}</h2>
                            <p>{timestampCalculator(elem?.created_at)}</p>
                        </div>
                    </Style.Element>
                )}
                {youtubeList?.data?.youtube_list?.length < 1 && <Style.Option>아직 유튜브 영상이 작성되지 않았습니다.</Style.Option>}
            </Style.List>

            <Pagenation maxPage={youtubeList?.data?.max_page} />

        </Style.Wrapper>
    )
}

export default YoutubeList